module.exports = __webpack_public_path__ + "img/img_maintenance.200862b6.svg";